import React from "react";
import { Box, Typography } from "@mui/material";

type MyTimesheetUserRequestSummaryCardProps = {
  weeklyTimeLabel: string;
  weeklyTimeValue: string | number;
  monthlyTimeLabel: string;
  monthlyTimeValue: string | number;
  isMobile: boolean;
};

export const MyTimesheetUserRequestSummaryCard = ({
  weeklyTimeLabel,
  weeklyTimeValue,
  monthlyTimeLabel,
  monthlyTimeValue,
  isMobile,
}: MyTimesheetUserRequestSummaryCardProps) => {
  return (
    <Box
      width={isMobile ? "auto" : "482px"}
      height="174px"
      padding="12px 16px"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      style={{
        backgroundColor: "#919699",
        borderRadius: "8px",
      }}
    >
      <Typography
        variant="body1"
        style={{
          color: "#ffffff",
        }}
      >
        {weeklyTimeLabel}
      </Typography>
      <Typography
        variant="h4"
        style={{
          color: "#ffffff",
        }}
      >
        {weeklyTimeValue}
      </Typography>
      <Box
        height="1px"
        style={{
          backgroundColor: "#ffffff",
          width: "100%",
          margin: "8px 0",
        }}
      />
      <Typography
        variant="body1"
        style={{
          color: "#ffffff",
        }}
      >
        {monthlyTimeLabel}
      </Typography>
      <Typography
        variant="h4"
        style={{
          color: "#ffffff",
        }}
      >
        {monthlyTimeValue}
      </Typography>
    </Box>
  );
};

export default MyTimesheetUserRequestSummaryCard;
